import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-wait',
  templateUrl: './loader-wait.component.html',
  styleUrls: ['./loader-wait.component.scss']
})
export class LoaderWaitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
